"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../util/index");

var restpaginator_1 = require("../restpaginator");

var userdescriptor_1 = require("../userdescriptor");

var UserDescriptors = function () {
  function UserDescriptors(services, url) {
    (0, _classCallCheck3["default"])(this, UserDescriptors);
    this.services = services;
    this.url = url;
  }

  (0, _createClass3["default"])(UserDescriptors, [{
    key: "getUserDescriptor",
    value: function () {
      var _ref = (0, _asyncToGenerator3["default"])(
      /*#__PURE__*/
      _regenerator2["default"].mark(function _callee(identity) {
        var url, response;
        return _regenerator2["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new index_1.UriBuilder(this.url).path(identity).build();
                _context.next = 3;
                return this.services.network.get(url);

              case 3:
                response = _context.sent;
                return _context.abrupt("return", new userdescriptor_1.UserDescriptor(this.services, response.body));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserDescriptor(_x) {
        return _ref.apply(this, arguments);
      }

      return getUserDescriptor;
    }()
  }, {
    key: "getChannelUserDescriptors",
    value: function () {
      var _ref2 = (0, _asyncToGenerator3["default"])(
      /*#__PURE__*/
      _regenerator2["default"].mark(function _callee2(channelSid) {
        var _this = this;

        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var url, response;
        return _regenerator2["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = new index_1.UriBuilder(this.url).arg('ChannelSid', channelSid).arg('PageToken', args.pageToken).build();
                _context2.next = 3;
                return this.services.network.get(url);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", new restpaginator_1.RestPaginator(response.body.users.map(function (x) {
                  return new userdescriptor_1.UserDescriptor(_this.services, x);
                }), function (pageToken) {
                  return _this.getChannelUserDescriptors(channelSid, {
                    pageToken: pageToken
                  });
                }, response.body.meta.prev_token, response.body.meta.next_token));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getChannelUserDescriptors(_x3) {
        return _ref2.apply(this, arguments);
      }

      return getChannelUserDescriptors;
    }()
  }]);
  return UserDescriptors;
}();

exports.UserDescriptors = UserDescriptors;